var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolCalc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#FFE5C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.42285H11.2778V7.02004H5V8.42285ZM13.4167 18.018H19V16.6433H13.4167V18.018ZM13.4167 15.016H19V13.6132H13.4167V15.016ZM7.44444 19H8.83333V16.5311H11.2778V15.1283H8.83333V12.6593H7.44444V15.1283H5V16.5311H7.44444V19ZM14.4444 10.4429L16.1389 8.73146L17.8333 10.4429L18.8333 9.43287L17.1389 7.72144L18.8333 6.01002L17.8333 5L16.1389 6.71142L14.4444 5L13.4444 6.01002L15.1389 7.72144L13.4444 9.43287L14.4444 10.4429Z",
    fill: "#FF9500",
    stroke: "#FF9500",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolCalc);
export default __webpack_public_path__ + "static/media/toolCalc.0a3a67f30949810e29082d49b0c0e4e4.svg";
export { ForwardRef as ReactComponent };